import { z } from 'zod';
import {
  CCRequirementsInputsSettings,
  CCResourceRulesSettings,
  CCResourcesWithShifts,
  CCShiftType,
} from '@/api/apis/resources/schedule';
import { DayOfWeek } from '@/types/date.types';
import { CCSchedulerSettingsInputsFormType, CCSchedulerSettingsRulesFormType } from './types';

export const getDefaultCCSettingInputsValues = (
  data: CCRequirementsInputsSettings,
): CCSchedulerSettingsInputsFormType => {
  return data;
};

export const getDefaultCCSettingRulesValues = (
  data: CCResourceRulesSettings,
  shiftsData?: CCResourcesWithShifts,
): CCSchedulerSettingsRulesFormType => {
  const safeCustomRules = data.customRules?.filter((r) => Boolean(shiftsData?.[r.resourceId]?.resource));

  return {
    ...data,
    customRules: safeCustomRules,
  };
};

const numberSchema = z.number({ message: 'Required' }).min(0);

const ccTypeSpecificRulesSchema = z
  .object({
    minOnCall: numberSchema,
    maxOnCall: numberSchema,
  })
  .refine(
    (data) => {
      return data.minOnCall <= data.maxOnCall;
    },
    { message: 'Max should be higher than Min', path: ['maxOnCall'] },
  );

const ccVacationDeductionRuleSchema = z.object({
  each: numberSchema,
  deduction: numberSchema,
});

const ccCustomRuleItemSchema = z.object({
  resourceId: z.uuid('Select Coordinator'),
  status: z.enum(CCShiftType, { message: 'Select Status' }),
  dayOfWeeks: z.array(z.enum(DayOfWeek)).nullish().optional(),
});

export const ccSchedulerSettingRulesFormSchema = z.object({
  tcOneTwoRules: ccTypeSpecificRulesSchema,
  tcThreeRules: ccTypeSpecificRulesSchema,
  weekendCount: numberSchema,
  deductionRule: ccVacationDeductionRuleSchema,
  customRules: z.array(ccCustomRuleItemSchema).optional(),
});

export const ccSchedulerSettingInputsFormSchema = z.object({
  onCallPerDay: numberSchema,
});
